import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Container,
  Grid,
  makeStyles,
  Card,
  CardContent,
  Typography,
  Avatar
} from '@material-ui/core';
import Page from 'src/components/Page';
import DashboardCard from './DashboardCard';
import Sales from './Sales';
import { useDispatch, useSelector } from 'react-redux';
import {
  AccountBalance,
  Money,
  TrendingUpOutlined,
  PersonOutlined,
  VpnKeyRounded,
  LocalLibraryOutlined
} from '@material-ui/icons';
import {
  getDashboardData,
  getDashboardBalance
} from 'src/store/actions/DashboardActions';
import DashboardGraph from './DashboardGraph';
import ReportsGraph from '../reports/components/ReportsGraph';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    backgroundColor: '#2C74B4',
    height: 30,
    width: 30,
    padding: 10
  }
}));

const SubUserDashboard = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [desktopValues, setDesktopValues] = useState({
    data: {
      customers: 0,
      keys: 0,
      pointLeft: 0,
      pointUsed: 0,
      requestCost: 0,
      successfulRequest: 0,
      failedRequest: 0,
      failedSummary: null,
      successSummary: null
    }
  });
  const [systemBalance, setSystemBalance] = useState(null);
  const dashboardData = useSelector((state) => state.Dashboard.dashboardData);
  const profile = useSelector((state) => state.Auth.companyProfile);

  useEffect(() => {
    // dispatch(getDashboardData());
    let response;
    async function getDashboardInfo() {
      await dispatch(getDashboardData());

      response = await dispatch(getDashboardBalance());
      if (response !== -1) {
        setSystemBalance(response);
      }
    }

    getDashboardInfo();
  }, []);

  useEffect(() => {
    if (dashboardData) {
      setDesktopValues((values) => ({
        ...values,
        data: {
          ...values.data,
          keys: dashboardData?.keys[0].total,
          requestCost: dashboardData?.requestCost[0].total,
          successfulRequest: dashboardData?.requestCount[0].successCount,
          failedRequest: dashboardData?.requestCount[0].failedCount,
          failedSummary: dashboardData?.failedSummary,
          successSummary: dashboardData?.successSummary
        }
      }));
    }
  }, [dashboardData]);

  return (
    <Page className={classes.root} title="Dashboard">
      <Container maxWidth={false}>
        <Grid container spacing={3}>
          <Grid item lg={3} sm={6} xl={3} xs={12}>
            <DashboardCard
              title="Rubies Account"
              icon={<AccountBalance />}
              value={profile?.rubacc}
            />
          </Grid>

          <Grid item lg={3} sm={6} xl={3} xs={12}>
            <DashboardCard
              title="Total System Points"
              icon={<TrendingUpOutlined fontSize="small" />}
              value={systemBalance?.totalPoint || 0}
            />
          </Grid>

          <Grid item lg={3} sm={6} xl={3} xs={12}>
            <DashboardCard
              title="Total Points Left"
              icon={<TrendingUpOutlined fontSize="small" />}
              value={systemBalance?.balance || 0}
            />
          </Grid>

          <Grid item lg={3} sm={6} xl={3} xs={12}>
            <DashboardCard
              title="Keys"
              icon={<VpnKeyRounded fontSize="small" />}
              value={desktopValues?.data.keys}
            />
          </Grid>

          <Grid item lg={3} sm={6} xl={3} xs={12}>
            <DashboardCard
              title="Cost of Request"
              icon={<Money fontSize="small" />}
              value={desktopValues?.data.requestCost}
            />
          </Grid>

          <Grid item lg={3} sm={6} xl={3} xs={12}>
            <DashboardCard
              title="Successful Request"
              icon={<TrendingUpOutlined fontSize="small" />}
              value={desktopValues?.data.successfulRequest}
            />
          </Grid>

          <Grid item lg={3} sm={6} xl={3} xs={12}>
            <DashboardCard
              title="Failed Request"
              icon={<TrendingUpOutlined fontSize="small" />}
              value={desktopValues?.data.failedRequest}
            />
          </Grid>

          <Grid item lg={3} sm={6} xl={3} xs={12}>
            {/* <DashboardCard
              title={
                <a
                  href="https://documenter.getpostman.com/view/938562/TVzRGHx7#2b0b2f55-5ec2-4a33-8364-3a53ca9a81ec"
                  target="_blank"
                >
                  Click here to view documentation
                </a>
              }
              icon={<LocalLibraryOutlined fontSize="small" />}
              // value={desktopValues?.data.successfulRequest}
            /> */}
            <Card>
              <CardContent>
                <Grid
                  container
                  justify="center"
                  style={{ display: 'flex', flexDirection: 'row' }}
                >
                  <Grid item>
                    <Avatar className={classes.avatar}>
                      {' '}
                      <LocalLibraryOutlined fontSize="small" />{' '}
                    </Avatar>
                  </Grid>
                  <Grid item style={{ overflow: 'hidden' }}>
                    <Typography color="textPrimary" variant="body1">
                      <a
                        href="https://documenter.getpostman.com/view/938562/TVzRGHx7#2b0b2f55-5ec2-4a33-8364-3a53ca9a81ec"
                        target="_blank"
                      >
                        Click here to view documentation
                      </a>
                    </Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>

          <Grid item lg={12} md={12} xl={12} xs={12}>
            {/* <DashboardGraph
              successSummary={desktopValues?.data.successSummary}
              failedSummary={desktopValues.data.failedSummary}
            /> */}
            <ReportsGraph isDashboard />
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
};

export default SubUserDashboard;
